import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { PaginationPage, PaginationResponse } from 'src/app/classes';
import { AbstractListWidgetInner, WidgetInnerView } from 'src/app/widget-inner';
import { FilterType, FilterTypes } from '../../../edit/edit-userfilter/edit-userfilter.component';
import { LocationService } from 'src/app/lib/location/services/location.service';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { showAnimation } from 'src/animations';
import { IWidgetProviderService, WIDGET_PROVIDER_SERVICE } from 'src/app/interfaces';
import { Location } from 'src/app/lib/location/classes';
import { MatDialog } from '@angular/material/dialog';
import { CreateLocationDialogComponent } from 'src/app/lib/location/components/dialog/create-location-dialog/create-location-dialog.component';
import { widgetAdderColor } from 'src/app/globals';

@Component({
  selector: 'app-location-widget-inner',
  templateUrl: './location-widget-inner.component.html',
  styleUrls: ['./location-widget-inner.component.css'],
  animations: [ showAnimation ]
})
export class LocationWidgetInnerComponent extends AbstractListWidgetInner<Location> {

  currentView;

  currentFilterType: FilterType<number> = FilterTypes.find(x => x.value == "Location");

  viewTitle: string = null;

  constructor(
    @Inject(WIDGET_PROVIDER_SERVICE) private _widgetProviderService: IWidgetProviderService,
    private _locationService: LocationService,
    private _router: Router,
    private _dialog: MatDialog
  ) {
    super();
    this.sortAttribute = "address.street";
    this.currentFilterType = FilterTypes.find(x => x.value == "Location");
    this.setInitialDefaultView();

    this.stringSearchProvider = (...args) => this._locationService.searchLocationsByString(...args);
    this.userFilterSearchProvider = (...args) => this._locationService.searchLocationsByUserFilter(...args);
  }

  addLocation(){
    this._dialog.open(CreateLocationDialogComponent, {
      panelClass: "no-padding-dialog-container",
      autoFocus: false
    });
  }

  editLocation(location: Location) {
    this._router.navigate(["/location-details", location.locationid]);
  }

  ngOnInit(): void {
    this._widgetProviderService.setWidgetInnerViews([
      {
        name: () => of('Neuen Standort anlegen'),
        icon: () => of('add'),
        onClick: () => {
          this.addLocation();
          return of(null);
        },
        color: () => of(widgetAdderColor)
      } as WidgetInnerView
    ]);
  }

  setDefaultView(view) {
    this.currentView = view;
    if (view.title) this.viewTitle = view.title;
    if (view.sortAttribute) this.sortAttribute = view.sortAttribute;
    if (view.sortDsc) this.sortDsc = view.sortDsc;

    this.userFilterIdentifier = 0;

    this.updateContentProvider(this.page.asObservable().pipe(switchMap((page: PaginationPage) => {
      return view.provider(this._locationService, page) as Observable<PaginationResponse<Location[]>>;
    })));
  }

  setInitialDefaultView() {
    this.setDefaultView(LocationWidgetDefaultViews[0]);
  }

  LocationWidgetDefaultViews = LocationWidgetDefaultViews;
}

export const LocationWidgetDefaultViews = [
  {
    title: "Zuletzt verwendet",
    icon: "history",
    sortAttribute: "accessed",
    sortDsc: true,
    paginationPage: { pageNumber: 1, pageSize: 20 } as PaginationPage,
    provider:  function (locationService: LocationService, page: PaginationPage): Observable<PaginationResponse<Location[]>> {
      return locationService.getUserLocationHistory(page);
    }
  }, {
    title: "Beobachtete",
    icon: "visibility",
    paginationPage: { pageNumber: 1, pageSize: 20 } as PaginationPage,
    provider:  function (locationService: LocationService, page: PaginationPage): Observable<PaginationResponse<Location[]>> {
      return locationService.getWatchedLocations(page);
    }
  }
];

